"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
// tslint:disable:jsx-no-lambda
var d3 = require("d3-hierarchy");
var React = require("react");
var Progress_1 = require("../Progress");
var TreeNode_1 = require("./TreeNode");
require("./TreeView.scss");
var TreeView = (function (_super) {
    __extends(TreeView, _super);
    function TreeView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TreeView.prototype.render = function () {
        if (!this.props.nodes) {
            return React.createElement(Progress_1.Progress, null);
        }
        var root = d3.stratify()
            .id(function (d) { return d.id; })
            .parentId(function (d) { return d.parentID; })(this.props.nodes);
        return (React.createElement("ul", { className: 'CommonUXTree' }, this.createNodes(root) || null));
    };
    TreeView.prototype.createNodes = function (node, array) {
        var _this = this;
        if (array === void 0) { array = []; }
        var _loop_1 = function (child) {
            var isExpanded = this_1.props.expandedNodeIDs.includes(child.data.id);
            var isSelected = this_1.props.selectedNodeIDs.includes(child.data.id);
            var nodeElement = (React.createElement(TreeNode_1.TreeNode, { nodeExpanded: function () { return _this.props.nodeExpandedCallback(child.data, child.height); }, nodeSelected: function () { return _this.props.nodeSelectedCallback(child.data, child.height); }, id: child.data.id, key: child.data.id + child.data.parentID, index: child.data.id + child.data.parentID, itemDepth: child.depth, isLeafNode: child.height === 0, nodeText: child.data.nodeText, nodeIcon: child.data.nodeIcon, isExpanded: isExpanded, isSelected: isSelected }));
            array.push(nodeElement);
            if (child.height > 0 && isExpanded) {
                this_1.createNodes(child, array);
            }
        };
        var this_1 = this;
        for (var _i = 0, _a = node.children.sort(function (a, b) { return a.data.nodeText.localeCompare(b.data.nodeText); }); _i < _a.length; _i++) {
            var child = _a[_i];
            _loop_1(child);
        }
        return array;
    };
    return TreeView;
}(React.Component));
exports.TreeView = TreeView;
//# sourceMappingURL=TreeView.js.map